exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-toolbar .v-toolbar__content{padding:0!important;max-height:40px!important}", ""]);

// exports
